<template>
  <v-dialog
    v-model="dialog"
    max-width="380"
    persistent
  >
    <v-card class="pa-3">
      <v-layout class="justify-center align-center">
        <v-flex xs7>
          <v-img
            :src="confirmationImage"
            :lazy-src="confirmationImage"
            contain
          />
        </v-flex>
      </v-layout>
      <v-card-title class="px-1 mx-1">
        <span class="subheading confirmation-text">{{ $t('message.bizgainOnboarding.confirmChangeObjective') }}<span class="font-weight-medium ml-1">{{ businessName }} </span></span>
      </v-card-title>

      <v-card-actions>
        <v-layout justify-center>
          <v-flex class="shrink">
            <v-btn
              color="primary"
              :class="{'px-3':$vuetify.breakpoint.xsOnly, 'px-4':!$vuetify.breakpoint.xsOnly}"
              @click="onContinue"
            >
              {{ $t('message.bizgainOnboarding.cancel') }}
            </v-btn>
          </v-flex>
          <v-flex class="shrink ml-3 pl-1">
            <v-btn
              outline
              color="primary"
              :class="{'px-2':$vuetify.breakpoint.xsOnly, 'px-3':!$vuetify.breakpoint.xsOnly}"
              @click="onChangeObjective"
            >
              {{ $t('message.bizgainOnboarding.changeObjective') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  VDialog,
  VCard,
  VCardActions,
  VCardTitle,
  VBtn,
  VImg,
  VLayout,
  VFlex
} from 'vuetify/lib';
import { mapActions, mapGetters } from 'vuex';
import {  bizgainOnboardingRoutes, bizgainOnboardingImage } from 'Features/bizgainOnboarding/constants';
import { updateBusinessDetailsFromDbSession } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { Chat } from 'Mixins/chat';

export default {
  mixins: [Chat],
  components: {
    VDialog,
    VCard,
    VCardActions,
    VCardTitle,
    VBtn,
    VImg,
    VLayout,
    VFlex
  },
  data() {
    return {
      dialog: true,
      bizgainOnboardingRoutes,
      confirmationImage: bizgainOnboardingImage.confirmation
    };
  },
  async created(){
    let bizgainOnboardingLocalStorage = JSON.parse(localStorage.getItem('bizgain-onboarding'));
    let sessionId = bizgainOnboardingLocalStorage && bizgainOnboardingLocalStorage.bizgainOnboarding && bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails && bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data && bizgainOnboardingLocalStorage.bizgainOnboarding.businessDetails.data.sessionId;
    if(sessionId){
      await updateBusinessDetailsFromDbSession(sessionId);
    }
  },
  computed: {
    ...mapGetters([
      'businessDetails',
      'disableChatSupport',
      'freshChatRestoreId',
      'freshChatExternalId',
      'businessName'
    ]),
    businessName(){
      return this.businessDetails && this.businessDetails.name;
    }
  },
  methods: {
    ...mapActions(['setBusinessDetails', 'patchBusinessDetails']),
    async onChangeObjective(){
      this.dialog = false;
      this.$router.push({ name: this.bizgainOnboardingRoutes.SelectObjective.name, params: { isAppFlow: true } });
    },
    onContinue(){
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.confirmation-text{
  text-align: center;
}
</style>